<main class="details-container">
  <section class="universityName-container">
    <section>
      <section class="table-container">
        <section>
          <mat-table [dataSource]="[application]" class="custom-table">
            <ng-container matColumnDef="fullName">
              <mat-header-cell *matHeaderCellDef
                >Bursar Full Name</mat-header-cell
              >
              <mat-cell *matCellDef="let app" data-label="Bursar Full Name">
                <p class="center-text">{{ app.fullName }}</p>
              </mat-cell>
            </ng-container>

            @if (currentTab === "approved" && isOverviewer) {
              <ng-container matColumnDef="Date of Commencement">
                <mat-header-cell *matHeaderCellDef
                  >Date of Commencement</mat-header-cell
                >
                <mat-cell
                  *matCellDef="let app"
                  data-label="Date of Commencement"
                >
                  {{ formatDate(app.date) }}
                </mat-cell>
              </ng-container>
            }

            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef
                >Bursary Amount</mat-header-cell
              >
              <mat-cell *matCellDef="let app" data-label="Bursary Amount">
                {{ app.amount | customCurrency }}
              </mat-cell>
            </ng-container>

            @if (
              currentTab === "In review" && isOverviewer && !isFirstApprover
            ) {
              <ng-container matColumnDef="approver">
                <mat-header-cell *matHeaderCellDef>Approver</mat-header-cell>
                <mat-cell *matCellDef="let app">
                  {{ app.approverName || getCurrentStatus() }}
                </mat-cell>
              </ng-container>
            }

            @if (
              (currentTab === "In review" || currentTab === "Invoice") &&
              isOverviewer
            ) {
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                <mat-cell
                  *matCellDef="let app"
                  [ngClass]="{ 'warn-invoice': showInvoiceWarning() }"
                >
                  {{
                    app.changeRequested
                      ? app.changeRequested
                      : getCurrentStatus() === "Invalid"
                        ? "Invoice in review"
                        : getCurrentStatus()
                  }}
                </mat-cell>
              </ng-container>
            }

            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let app">
                @if (currentTab !== "Contract") {
                  <section class="button-container">
                    @if (
                      app.applicationId !== -1 &&
                      currentTab == "In review" &&
                      showNudgeButton
                    ) {
                      <button
                        mat-flat-button
                        color="accent"
                        (click)="resendExecutiveEmail()"
                      >
                        {{ buttonAction.NUDGE_EXECUTIVE }}
                      </button>
                    }
                    @if (
                      app.applicationId !== -1 &&
                      currentTab !== "Fund spread" &&
                      currentTab !== "Email Failed" &&
                      currentTab !== "Contract"
                    ) {
                      <button
                        mat-flat-button
                        color="accent"
                        (click)="navigateToDetailsPage(app.applicationGuid)"
                      >
                        {{ buttonAction.VIEW }} {{ moreDetails }}
                      </button>
                    }
                    @if (
                      app.applicationId !== -1 && currentTab == "Email Failed"
                    ) {
                      <button
                        mat-flat-button
                        color="accent"
                        (click)="navigateToEmailFailed(app.applicationGuid)"
                      >
                        {{ buttonAction.VIEW }}
                      </button>
                    }
                    @if (
                      currentTab === "Invoice" &&
                      showUploadFilesButton() &&
                      !isAwaitingFundDistribution()
                    ) {
                      <button
                        mat-flat-button
                        color="primary"
                        class="upload-button"
                        (click)="openAdminFileUploadDialog()"
                      >
                        {{
                          isFirstApprover
                            ? buttonAction.UPLOAD_INVOICES
                            : buttonAction.VIEW_INVOICES
                        }}
                      </button>
                    }
                    @if (isAwaitingFundDistribution()) {
                      <button
                        mat-flat-button
                        color="primary"
                        class="upload-button"
                        (click)="spreadFundsDialog(app.applicationId)"
                      >
                        {{
                          buttonAction.MOVEFUNDS.replace("Move", "Distribute")
                        }}
                      </button>
                    }
                    @if (currentTab === "Payment" && isApprover) {
                      <button
                        mat-flat-button
                        color="primary"
                        class="upload-button"
                        (click)="openAdminFileUploadDialog()"
                      >
                        {{ buttonAction.UPLOAD }} payment/s
                      </button>
                    }
                  </section>
                }

                @if (currentTab == "Contract") {
                  <section class="contract-button">
                    @if (app.applicationId !== -1 && currentTab == "Contract") {
                      <button
                        mat-flat-button
                        color="accent"
                        class="view-button"
                        (click)="navigateToDetailsPage(app.applicationGuid)"
                      >
                        {{ buttonAction.VIEW }} details
                      </button>
                    }
                    @if (
                      isApprover &&
                      (getCurrentStatus() === "Awaiting Fund Distribution" ||
                        !isFundSpread)
                    ) {
                      <button
                        mat-flat-button
                        color="primary"
                        (click)="spreadFundsDialog(app.applicationId)"
                      >
                        {{
                          buttonAction.MOVEFUNDS.replace("Move", "Distribute")
                        }}
                      </button>
                    }
                    @if (
                      isApprover &&
                      (getCurrentStatus() === "Contract" || isFundSpread)
                    ) {
                      <button
                        mat-flat-button
                        color="primary"
                        (click)="confirmAction()"
                      >
                        {{ buttonAction.UPLOAD }} contract
                      </button>
                    }
                  </section>
                }
              </mat-cell>
            </ng-container>

            @if (index == 0) {
              <mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></mat-header-row>
            }
            <mat-row
              *matRowDef="let row; columns: displayedColumns"
              [ngStyle]="{
                'border-bottom':
                  applicationArrayLength - 1 === index
                    ? 'none'
                    : '1px solid var(--primary-color)'
              }"
            ></mat-row>
          </mat-table>
        </section>
      </section>
    </section>
  </section>
</main>
